import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export interface CheckboxList {
    label: string;
    value: any;
    checked: boolean;
}

@Component({
    selector: 'checkbox-list',
    templateUrl: './checkboxList.component.html',
    styleUrls: ['./checkboxList.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckboxListComponent),
            multi: true
        }
    ],
    standalone: false
})
export class CheckboxListComponent implements ControlValueAccessor {
    @Input() helpContentId: string;
    @Input() helpDisabled: boolean;
    @Input() viewOnly: boolean;

    value: CheckboxList[];
    disabled: boolean;

    get isAllChecked(): boolean {
        const selectedCount = this.value ? this.value.filter(item => item.checked).length : 0;
        if (selectedCount === 0) {
            return false;
        } else if (selectedCount === this.value.length) {
            return true;
        } else {
            return null;
        }
    }

    private onChange: (val: CheckboxList[]) => void = (val) => {
        return null;
    };
    private onTouched: () => void = () => {
        return null;
    };

    writeValue(value: CheckboxList[]): void {
        this.value = value;
    }

    setDisabledState(disabled: boolean): void {
        this.disabled = disabled;
    }

    next(): void {
        this.onChange(this.value);
        this.onTouched();
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    selectAll(): void {
        const isAllChecked = this.isAllChecked;
        this.value.forEach(item => {
            item.checked = !isAllChecked;
        });
        this.next();
    }

    checkChanged(checked: boolean, item: CheckboxList): void {
        item.checked = checked;
        this.next();
    }
}
